import React from "react";
import FilterPanel from "../../../../shared/components/generic/filter-panel/filter-panel";
import "./assessment-layout.css";

const AssessmentLayout = ({
	children,
	filterVisible = true,
	filterTitle = "Filtros de Apuração",
	filterFormId = "assessment-filter-form",
	filterFields = [],
	filterResetKey = 0,
	isEmpty = false,
	hasError = false,
	onFilterSubmit,
	onFilterClear,
	filterErrors = {},
	onFilterFieldChange,
}) => {
	return (
		<div
			className={[
				"assessment-layout",
				filterVisible
					? "assessment-layout--with-filter"
					: "assessment-layout--without-filter",
				(isEmpty || hasError) ? "assessment-layout--empty" : ""
			].filter(Boolean).join(" ")}
		>
			<div className="assessment-layout__content">
				{children}
			</div>

			{filterVisible && (
				<aside className="assessment-layout__filter-column">
					<FilterPanel
						key={`${filterFormId}-${filterResetKey}`}
						title={filterTitle}
						formId={filterFormId}
						formFields={filterFields}
						position="right"
						onSubmit={onFilterSubmit}
						onClear={onFilterClear}
						errors={filterErrors}
						onFieldChange={onFilterFieldChange}
					/>
				</aside>
			)}
		</div>
	);
};

export default AssessmentLayout;